import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as _ from 'lodash';

import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

declare var require: any;

// Partner registrations service
// Stores registrations to warranty S3 userdata, sends machine-events to machinery
// Searches registered machines from machinery machines

export interface MachineRegistration {
    id: string;
    company: string;
    partnerId: string;
    serialNumber: string;
    productId: string;
    productInfo: any;
    manufactureDate?: string;
    deliveryDate?: string;
    salesDate?: string;
    partnerRegistrationDate?: string;
    warrantyExpireDate?: string;
    registeredCompany?: string;
    registeredPartnerId?: string;
    registeredPartnerName?: string;
    registeredOrganizationName?: string;
    registeredEndCustomerName?: string;
    endCustomerRegistrationDate?: string;
}

@Injectable()
export class RegistrationsService {

    BACKENDURL: string;

    constructor(
        private appConfigService: AppConfigService,
        private authService: AuthService,
        private http: HttpClient
    ) {
        this.BACKENDURL = this.appConfigService.config.warrantyBackendUrl;
    }

    get token() {
        return this.authService.accessToken;
    }

    getRegistration(company, partnerId, serialNumber) {
        console.log('getRegistration', company, partnerId, serialNumber);
        return this.http.get(`${this.BACKENDURL}/registrations/company/${company}/partner/${partnerId}/${serialNumber}`, { headers: this._getHeaders() });
    }

    getRegistrationById(serialNumber) {
        console.log('getRegistrationById', serialNumber);
        return this.http.get(`${this.BACKENDURL}/registrations/${serialNumber}`, { headers: this._getHeaders() });
    }

    saveRegistration(company, partnerId, serialNumber, registration) {
        console.log('saveRegistration', company, partnerId, serialNumber, registration);
        if (!serialNumber) {
            // Create new (POST)
            return this.http.post(`${this.BACKENDURL}/registrations/company/${company}/partner/${partnerId}/`, JSON.stringify(registration), { headers: this._getHeaders() });
        } else {
            // Update existing one (PUT)
            return this.http.put(`${this.BACKENDURL}/registrations/company/${company}/partner/${partnerId}/${serialNumber}`, JSON.stringify(registration), { headers: this._getHeaders() });
        }
    }

    deleteRegistration(company, partnerId, serialNumber) {
        return this.http.delete(`${this.BACKENDURL}/registrations/company/${company}/partner/${partnerId}/${serialNumber}`, { headers: this._getHeaders() });
    }

    // Returns search params ?search=
    // key=value&key2=value2,value22
    // key%3Dvalue%26key2%3Dvalue2%2Cvalue22
    _getSearchString(params) {
        const queryStringParams = _.map(params, (p) => {
            return p.key + '%3D' + p.value;
        }).join('%26').replace(/,/g, '%2C');
        if (queryStringParams) {
            return `&search=${queryStringParams}`;
        } else {
            return '';
        }
    }

      // Returns sort params ?sort=key:direction;key2:direction2
      _getSortString(params: Array<{ key: string; direction: string }>) {
        console.log(params);
        const queryStringParams = _.map(params, (p) => {
            return p.key + ':' + p.direction;
        }).join(',');
        return queryStringParams;
    }

    searchRegistrationsAll(params, size = 50, from = 0, sort: Array<{ key: string; direction: string }>): Observable<Array<MachineRegistration>> {
        console.log('searchRegistrationsAll', params, size);
        return this.http.get(`${this.BACKENDURL}/registrations?size=${size}&from=${from}${this._getSearchString(params)}&sort=${this._getSortString(sort)}`,
            { headers: this._getHeaders() }
        ) as Observable<Array<MachineRegistration>>;
    }

    searchRegistrationsByCompany(company, params, size = 50, from = 0, sort: Array<{ key: string; direction: string }>): Observable<Array<MachineRegistration>> {
        console.log('searchRegistrationsByCompany', company, params, size);
        return this.http.get(`${this.BACKENDURL}/registrations/company/${company}?size=${size}&from=${from}${this._getSearchString(params)}&sort=${this._getSortString(sort)}`,
            { headers: this._getHeaders() }
        ) as Observable<Array<MachineRegistration>>;
    }

    searchRegistrationsByPartner(company, partnerId, params, size = 50, from = 0, sort: Array<{ key: string; direction: string }>): Observable<Array<MachineRegistration>> {
        console.log('searchRegistrationsByPartner', company, partnerId, params, size);
        return this.http.get(`${this.BACKENDURL}/registrations/company/${company}/partner/${partnerId}?size=${size}&from=${from}${this._getSearchString(params)}&sort=${this._getSortString(sort)}`,
            { headers: this._getHeaders() }
        ) as Observable<Array<MachineRegistration>>;
    }

    _getHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
        });
    }

}
